module.exports = __webpack_public_path__ + "static/media/21c-01-HOME_ST-2021-35x47cm-oleo-sobre-madera.1d7d113b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/21c/21c-01-HOME_ST-2021-35x47cm-oleo-sobre-madera.jpg
// module id = 257
// module chunks = 0